import { render, staticRenderFns } from "./high-bounce-rate.vue?vue&type=template&id=24b9387f&"
import script from "./high-bounce-rate.vue?vue&type=script&lang=js&"
export * from "./high-bounce-rate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../usr/local/lib/node_modules/@vue/cli-service-global/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports